<template>
  <v-card>
    <v-container fluid>
      <v-row dense align="center">
        <v-col>
          <v-row dense>
            <v-col>
              Executado em
              {{ executedAt | moment("DD/MM/YYYY hh:mm") }}
            </v-col>
          </v-row>

          <!-- <v-row dense>
            <v-col class="font-weight-bold"> {{ index + 1 }} - {{ treatmentTemplateName }} </v-col>
          </v-row> -->
        </v-col>

        <v-spacer />

        <v-col cols="auto"> </v-col>

        <v-col cols="auto">
          <authorization
            v-if="allowEdit"
            permissionKey="attendance_treatment"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  :to="`tratamentos/${treatment.id}`"
                  v-if="authorization"
                >
                  <v-icon>eva-edit-outline</v-icon>
                </v-btn>
              </template>

              <span>
                Editar
              </span>
            </v-tooltip>
          </authorization>

          <authorization
            v-if="allowDelete"
            permissionKey="attendance_treatment"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  @click="deleteTreatment"
                  v-if="authorization"
                >
                  <v-icon>eva-trash-outline</v-icon>
                </v-btn>
              </template>

              <span>
                Excluir
              </span>
            </v-tooltip>
          </authorization>

          <v-btn icon small @click="showContent = !showContent">
            <v-icon v-if="showContent">eva-chevron-up-outline</v-icon>
            <v-icon v-else>eva-chevron-down-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-show="showContent">
        <TreatmentForm :attendance="attendance" :treatment="treatment" :disabled="true" />
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import TreatmentForm from "@/components/treatment/form.vue";

  export default {
    name: "TreatmentListItem",
    props: {
      attendance: Object,
      treatment: Object,
      index: Number,
      refreshList: Function,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      TreatmentForm,
    },
    data() {
      return {
        showContent: false,
      };
    },
    computed: {
      treatmentTemplateName() {
        if (this.treatment?.treatmentTemplate?.name) {
          return this.treatment.treatmentTemplate.name;
        }

        return "Tratamentos";
      },
      executedAt() {
        if (this.treatment?.executedAt) {
          return this.$moment(this.treatment.executedAt, "YYYY-MM-DD HH:mm:ss ZZ");
        }

        return null;
      },
    },
    methods: {
      deleteTreatment() {
        this.apolloMutate({
          mutation: require("@/graphql/treatment/delete_treatment.gql"),
          variables: {
            treatmentId: this.treatment.id,
          },
        }).then(() => {
          this.refreshList();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
